var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmojiEvents = function SvgEmojiEvents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emoji_events_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M15.833 4.167h-1.666V2.5H5.833v1.667H4.167c-.917 0-1.667.75-1.667 1.666v.834c0 2.125 1.6 3.858 3.658 4.116a4.17 4.17 0 0 0 3.009 2.467v2.583H5.833V17.5h8.334v-1.667h-3.334V13.25a4.17 4.17 0 0 0 3.009-2.467C15.9 10.525 17.5 8.792 17.5 6.667v-.834c0-.916-.75-1.666-1.667-1.666m-11.666 2.5v-.834h1.666v3.184a2.51 2.51 0 0 1-1.666-2.35m5.833 5a2.507 2.507 0 0 1-2.5-2.5v-5h5v5c0 1.375-1.125 2.5-2.5 2.5m5.833-5c0 1.083-.7 2-1.666 2.35V5.833h1.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emoji_events_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgEmojiEvents;